<template>
  <div class="player-footer">
    <div>
      <btn icon large @click="toggleVideo"><play-icon :isPlaying="playing"/></btn>
      <p v-if="shouldShowPlaylistData">{{ playlistTitle }}</p>
      <p v-if="!shouldShowPlaylistData || !isPortrait">{{ videoTitle }}</p>
    </div>
    <div>
      <btn icon medium @click="changeVideo"><next-episode-icon/></btn>
      <btn icon medium @click="toggleEpisodes"><episodes-icon/></btn>
      <volume :isPortrait="isPortrait" />
      <fullscreen-btn v-if="isFullscreenAvailable" />
    </div>
  </div>
</template>

<script>
import KeyProcessor from '@/js/KeyProcessor'
import { mapState, mapActions, mapGetters } from 'vuex'

export default {
  name: 'player-footer',
  computed: {
    ...mapState({
      isPortrait: state => state.window.isPortrait,
      isMobile: state => state.window.isMobile,
      title: state => state.video.title,
      playing: state => state.video.playing,
      episode: state => state.video.playlistData.episode,
      playlistTitle: state => state.video.playlistData.title,
      playlistId: state => state.video.playlistData.id
    }),
    ...mapGetters({ getVideosFromPlaylist: 'contentTree/findVideosFromPlaylist' }),
    shouldShowPlaylistData() {
      return this.getVideosFromPlaylist(this.playlistId).length !== 1
    },
    videoTitle() {
      let title = ''
      if (this.shouldShowPlaylistData) {
        title += `Ep${this.episode} - `
      }

      title += this.title
      return title
    },
    isFullscreenAvailable() {
      return document.fullscreenEnabled
    }
  },
  methods: {
    ...mapActions({ toggle: 'video/toggle', nextVideo: 'video/next' }),
    toggleEpisodes(evt) {
      document.activeElement.blur()
      this.$emit('toggleEpisodes', evt)
    },
    toggleVideo() {
      document.activeElement.blur()
      this.toggle()
    },
    changeVideo() {
      document.activeElement.blur()
      this.nextVideo()
    }
  },
  mounted() {
    this.keyProcessor = new KeyProcessor({ 32: this.toggle })
  },
  destroyed() {
    this.keyProcessor.removeListener()
  }
}
</script>

<style lang="scss" scoped>
.player-footer {
  padding: 15px;
  display: flex;
  flex-grow: 1;
  background-color: $player-hud-background-color;

  & > div {
    display: flex;
    align-items: center;

    &:first-child {
      overflow: hidden;
      flex-grow: 1;
      color: white;

      & > .btn {
        margin: 0 9px;
      }

      p {
        white-space: nowrap;
        font-size: 1rem;
        padding: 0 9px;

        &:last-child {
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }

    &:last-child {
      & > * {
        margin: 0 1rem;
      }

      & > .hidden {
        margin: 0;
      }
    }
  }
}
</style>
